import { render, staticRenderFns } from "./ExamStart.vue?vue&type=template&id=65e90145&"
import script from "./ExamStart.vue?vue&type=script&lang=js&"
export * from "./ExamStart.vue?vue&type=script&lang=js&"
import style0 from "./ExamStart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports